import { hasPermission } from "utils/permissionsUtils";
import { PERMISSIONS } from "permissions/permissions";

// Communication Permissions
export const canCall = () =>
  hasPermission(PERMISSIONS.LEADS.COMMUNICATION.CALL);

export const canSendSMS = () =>
  hasPermission(PERMISSIONS.LEADS.COMMUNICATION.SMS);

export const canSendEmail = () =>
  hasPermission(PERMISSIONS.LEADS.COMMUNICATION.EMAIL);

// export const canWhatsApp = () =>
//   hasPermission(PERMISSIONS.LEADS.COMMUNICATION.WHATSAPP);

// Follow-ups Permissions
export const canViewFollowUps = () =>
  hasPermission(PERMISSIONS.LEADS.FOLLOW_UPS.VIEW);

export const canCreateFollowUp = () =>
  hasPermission(PERMISSIONS.LEADS.FOLLOW_UPS.CREATE);

export const canEditFollowUp = () =>
  hasPermission(PERMISSIONS.LEADS.FOLLOW_UPS.EDIT);

export const canDeleteFollowUp = () =>
  hasPermission(PERMISSIONS.LEADS.FOLLOW_UPS.DELETE);

// Lead Page & Dropdowns
export const canViewLeadsPage = () =>
  hasPermission(PERMISSIONS.LEADS.LEAD.VIEW);

export const canManageLeadDropdown = () =>
  hasPermission(PERMISSIONS.LEADS.LEAD.MANAGE_DROPDOWN);

// Lead Import Permissions
export const canDownloadTemplate = () =>
  hasPermission(PERMISSIONS.LEADS.LEAD_IMPORT.DOWNLOAD_TEMPLATE);

export const canUploadExcel = () =>
  hasPermission(PERMISSIONS.LEADS.LEAD_IMPORT.UPLOAD_EXCEL);

// Lead Export Permissions
export const canExportLeads = () =>
  hasPermission(PERMISSIONS.LEADS.LEAD_EXPORT.DOWNLOAD);

// Manage Lead Actions
export const canViewLeadDetails = () =>
  hasPermission(PERMISSIONS.LEADS.MANAGE_LEAD.VIEW_DETAILS);

export const canCreateLead = () =>
  hasPermission(PERMISSIONS.LEADS.MANAGE_LEAD.CREATE);

export const canEditLead = () =>
  hasPermission(PERMISSIONS.LEADS.MANAGE_LEAD.EDIT);

export const canDeleteLead = () =>
  hasPermission(PERMISSIONS.LEADS.MANAGE_LEAD.DELETE);

export const canAssignLead = () =>
  hasPermission(PERMISSIONS.LEADS.MANAGE_LEAD.ASSIGN);

export const canConvertLeadToJob = () =>
  hasPermission(PERMISSIONS.LEADS.MANAGE_LEAD.CONVERT_TO_JOB);
